// exportToExcel.js
import React from "react";
import * as XLSX from 'xlsx';
import moment from 'moment';

export const exportToExcel = (data, columns, infoData, title, user) => {
    const headers = columns.map((col) => col.label);
    const fields = columns.map((col) => col.dataIndex);

    const excelData = data.map((row) =>
        fields.map((field, index) => {
            const column = columns[index];
            const {label, render} = column;
            let value = row[label];

            if (field === "acc" && Array.isArray(value)) {
                const x = value[1] !== "-" ? value[1] : "Bilinmiyor";
                const y = value[3] !== "-" ? value[3] : "Bilinmiyor";
                const z = value[5] !== "-" ? value[5] : "Bilinmiyor";
                value = `X: ${x} | Y: ${y} | Z: ${z}`;
            }

            if (field === 'createdAt' && moment(value, 'YYYY-MM-DD HH:mm:ss.SSSSSS', true).isValid()) {
                return moment(value, 'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD/MM/YYYY HH:mm:ss');
            }
            if (render && React.isValidElement(value)) {
                return value.props.children;
            }
            return value;
        })
    );

    // Create a new worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([]);
    if (infoData) {
        const startDate = infoData.start_date ? moment.utc(infoData.start_date).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss') : 'Tanımlanmadı';
        const endDate = infoData.end_date ? moment.utc(infoData.end_date).add(3, 'hours').format('DD/MM/YYYY HH:mm:ss') : 'Tanımlanmadı';
        const reportCreationDate = moment().format('DD/MM/YYYY HH:mm:ss'); // Rapor oluşturulma tarihi
        const driver = infoData.driverName && infoData.driverSurname ? `${infoData.driverName} ${infoData.driverSurname}` : 'Tanımlanmadı';
        const chassisNumber = infoData.chassisNumber ? `${infoData.chassisNumber}` : 'Tanımlanmadı';
        // Add info data as per the new layout
        XLSX.utils.sheet_add_aoa(worksheet, [
            ['Kapı Numarası:', infoData.operationNumber || 'Tanımlanmadı', '', 'Rapor Tarih Aralıkları:', `${startDate} - ${endDate}`],
            ['Araç Plakası:', infoData.plateNumber || 'Tanımlanmadı', '', 'Sürücü Adı / Soyadı ', driver],
            ['Şase Numarası:', chassisNumber || 'Tanımlanmadı', '', 'Hat Numarası ', 'Tanımlanmadı'],
            ['Rapor Oluşturulma Tarihi:', reportCreationDate, '', 'Rapor oluşturan :', user]
        ], {origin: 'A1'});
    }

    // Add some blank rows to create space before the headers
    XLSX.utils.sheet_add_aoa(worksheet, [[]], {origin: 'A4'});
    XLSX.utils.sheet_add_aoa(worksheet, [[]], {origin: 'A5'});

    // Add headers starting from row 6 (after the blank rows)
    XLSX.utils.sheet_add_aoa(worksheet, [headers], {origin: 'A6'});

    // Add data starting from row 7 (after the headers)
    XLSX.utils.sheet_add_json(worksheet, excelData, {origin: 'A7', skipHeader: true});

    // Adjust column widths based on the content length
    const columnWidths = columns.map((col) => ({wch: Math.max(col.label.length, 15)}));
    worksheet['!cols'] = columnWidths;

    // Set the row height for specific rows (e.g., row 2)
    worksheet['!rows'] = [{}, {hpx: 15}];

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, title);

    // Export the workbook to Excel
    XLSX.writeFile(workbook, `${title}.xlsx`);
};
